'use client';

import { dataExpTagConfig } from '@/components/product/const';
import { CategoryNavWrapper } from '@/styles/product';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/25217';
import { useEffect, useRef, useState } from 'react';

import { useScroll } from '@/components/hooks';
type Props = {
  navList: any[];
  sticky?: boolean | number;
  targetClassName?: string;
  className?: string;
  skuId: string;
};

export default function CategoryNav({ navList, sticky, targetClassName, className, skuId }: Props) {
  // const { y } = useScroll();
  const [indexActive, setIndexActive] = useState<number>(0);
  const [scrollTargets, setScrollTargets] = useState<any[]>([]);
  const [stickied, setStickied] = useState<boolean>(false);
  const { y } = useScroll();
  const navRef = useRef(null);
  const resizeObserverRef = useRef<any>(null);
  const onNavClick = (index: number, text: string) => {
    setIndexActive(index);
    const positionY = scrollTargets?.[index]?.[0] || 0;

    if (positionY) {
      window.scrollTo(0, positionY);
    }

    sendClickTrack.Productdetail_FloorAnchor_Click({
      mainskuid: skuId,
      anchorName: String(text),
    });
  };

  useEffect(() => {
    if (sticky) {
      const element = document.getElementById('productDetailContainer');

      if (!element) return;

      const resizeObserver = new ResizeObserver((entries) => {
        const targets = targetClassName ? element.querySelectorAll(`.${targetClassName}`) : [];
        setScrollTargets(
          [...targets].map((dom, index) => {
            // 48 是 nav 的高度
            // @ts-ignore
            const top = (dom?.offsetTop || 0) - 48;

            const topHeight = top + (dom?.getBoundingClientRect()?.height || 0);
            return [top, topHeight];
          }),
        );
      });

      resizeObserver.observe(element);

      resizeObserverRef.current = resizeObserver;

      return () => {
        // 在组件销毁时销毁 ResizeObserver 实例
        if (resizeObserverRef.current) {
          resizeObserverRef.current?.disconnect();
        }
      };
    }
  }, []);

  useEffect(() => {
    if (sticky) {
      const itemFirstTop = scrollTargets[0]?.[0];
      const itemFirstLastTop = scrollTargets[scrollTargets.length - 1]?.[1];

      if (scrollTargets?.length && itemFirstTop < y && itemFirstLastTop > y) {
        scrollTargets.forEach((item, index) => {
          if (y > item[0] && y < item[1]) {
            setIndexActive(index);
          }
        });
        setStickied(true);
      } else {
        setStickied(false);
      }

      if (y < itemFirstTop) {
        setIndexActive(0);
      }
    }
  }, [y]);

  return (
    <CategoryNavWrapper
      className={className}
      data-sticky={sticky}
      data-stickied={stickied}
      ref={navRef}
    >
      <div className='cate-nav-list'>
        {navList.map((nav: string, index: number) => {
          return (
            <div
              key={index}
              className={`cate-nav-item ${index === indexActive ? 'active' : ''}`}
              onClick={() => onNavClick(index, nav)}
              exptag={'exp|' + EXPOSURE_RECORD.Productdetail_FloorAnchor_Expo}
              data-exptag-config={dataExpTagConfig}
              data-exptag-json-param={JSON.stringify({ mainskuid: skuId, anchorName: nav })}
            >
              {nav}
            </div>
          );
        })}
      </div>
    </CategoryNavWrapper>
  );
}
